import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setLevelCarePerProtocolOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getLevelCarePerProtocolOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getLevelCarePerProtocolOptions])
    const { entity } = response
    yield put(setLevelCarePerProtocolOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getLevelCarePerProtocolOptions() error: ${e}`))
  }
}

export function* getLevelCarePerProtocolOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getLevelCarePerProtocolOptions)
}
